// removed by extract-text-webpack-plugin
module.exports = {"login":"Wo_xp-tCc5kpp1FIOV7yH","close":"_3zX_2CjvU0zo2v2NWBb_s0","loginMes":"_3ylUGWIXSCsJL6mP8mfYst","loginLabel":"_3zZsgpBiXQKGDq1AQ0mwaB","labelMsg":"_1h8IZ-Du_4bCZLEoihCmq5","zhuan_a":"lu5MaP5tsHyIRXjvIWLIM","zhuan":"_3DnYWu7OXH4bjlgyuR09F6"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AttentionSuccessModal/AttentionSuccessModal.scss
 ** module id = 952
 ** module chunks = 0
 **/